import Vue from 'vue'
import VueRouter from 'vue-router'
import { Trans } from '@/plugins/Translation'

const originalPush = VueRouter.prototype.push;
VueRouter.prototype.push = function push(location) {
  return originalPush.call(this, location).catch(err => err)
};

Vue.use( VueRouter );

const routes_ = [
  { 
    path: '*', 
    redirect: '/en' // @todo : detect if navigator language is part of the "supported languages" and redirect as needed
  }, 
  {
    path: '/:lang',
    name: 'home',
    component: () => import('./views/Home.vue'),  
    children : [  
    ]
  },
  {
    path: '/:lang/registry-directory',
    name: 'registry-directory',
    component: () => import('./views/RegistryDirectory.vue') 
  },
  {
    path: '/:lang/registry-directory/:country_id',
    name: 'registry-directory-reg',
    component: () => import('./views/RegistryDirectory.vue') 
  },
  {
    path: '/:lang/registry-directory-table',
    name: 'registry-directory-table',
    component: () => import('./views/RegistryDirectoryTable.vue') 
  },
  {
    path: '/:lang/registry-directory/:slug/:id',
    name: 'registry-report',
    component: () => import('./views/Registry.vue') 
  },
  {
    path: '/:lang/standards',
    name: 'standards',
    component: () => import('./views/Standards.vue')
  },
  {
    path: '/:lang/standards/:slug',
    name: 'standards_slug',
    component: () => import('./views/Standards.vue')
  },
  // -------------- STATIC PAGES ----------------
  {
    path: '/:lang/annual-meetings',
    name: 'meetings',
    component: () => import('./views/Meetings.vue')
  },
  {
    path: '/:lang/annual-meeting/:id',
    name: 'meeting_slug',
    component: () => import('./views/Meetings.vue')
  },
  {
    path: '/:lang/news',
    name: 'news',
    component: () => import('./views/News.vue')
  },
  {
    path: '/:lang/news/:id',
    name: 'news_slug',
    component: () => import('./views/News.vue')
  },
  {
    path: '/:lang/fellowships_prizes',
    name: 'fellowships_prizes',
    component: () => import('./views/Fellowships_Prices.vue')
  },
  {
    path: '/:lang/fellowships_prizes/:slug',
    name: 'fellowships_prizes_slug',
    component: () => import('./views/Fellowships_Prices.vue')
  },
  {
    path: '/:lang/about',
    name: 'about',
    component: () => import('./views/About.vue')
  },
  {
    path: '/:lang/about-iacr/:slug',
    name: 'about_slug',
    component: () => import('./views/About.vue')
  },
  // ----------- CI5 2.0 INDEX, ABOUT and VOLUMES
  {
    path: '/:lang/ci5-2.0',
    name: 'ci5_dataviz',
    component: () => import('./views/ci5-2.0/Index.vue')
  },
  {
    path: '/:lang/ci5-2.0/about',
    name: 'ci5_about',
    component: () => import('./views/ci5-2.0/About.vue')
  },
  {
    path: '/:lang/ci5-2.0/volumes',
    name: 'ci5_volumes',
    component: () => import('./views/ci5-2.0/Index.vue')
  },
  {
    path: '/:lang/ci5-2.0/volume/:num_volume',
    name: 'ci5_slug',
    component: () => import('./views/ci5-2.0/Volume.vue')
  },
  // -------------- DATAVIZ  ----------------
  // -------------- DATAVIZ - Trends/Bars/Tables/Pops (CI5I_XII) ----------------
  {
    path: '/:lang/ci5-2.0/dataviz/:volume/tables', 
    name: 'dataviz_tables',
    component: () => import('./views/visualizations/Tables.vue') , 
  },
  {
    path: '/:lang/ci5-2.0/dataviz/:volume/age_specific', 
    name: 'dataviz_age_specific',
    component: () => import('./views/visualizations/AgeSpecific.vue') ,
  },
  { 
    path: '/:lang/ci5-2.0/dataviz/:volume/bars', 
    name: 'dataviz_bars',
    component: () => import('./views/visualizations/Bars.vue') ,
  },
  { 
    path: '/:lang/ci5-2.0/dataviz/:volume/population_pyramid', 
    name: 'dataviz_population_pyramid',
    component: () => import('./views/visualizations/PopulationPyramid.vue') ,
  },
  { 
    path: '/:lang/ci5-2.0/dataviz/:volume/dictionary', 
    name: 'dataviz_dictionary',
    component: () => import('./views/visualizations/Dictionnary.vue') ,
  },
  // -------------- DATAVIZ - Trends/Bars/Tables/Pops (CI5Plus) ----------------
  {
    path: '/:lang/ci5-2.0/dataviz/plus/trends', 
    name: 'dataviz_trends_ci5plus',
    ci5plus: true ,
    component: () => import('./views/visualizations/Trends.vue') , 
  },
  {
    path: '/:lang/ci5-2.0/dataviz/plus/tables', 
    name: 'dataviz_tables_ci5plus',
    ci5plus: true ,
    component: () => import('./views/visualizations/Tables.vue') , 
  },
  {
    path: '/:lang/ci5-2.0/dataviz/plus/age_specific', 
    name: 'dataviz_age_specific_ci5plus',
    ci5plus: true ,
    component: () => import('./views/visualizations/AgeSpecific.vue') ,
  },
  { 
    path: '/:lang/ci5-2.0/dataviz/plus/bars', 
    name: 'dataviz_bars_ci5plus',
    ci5plus: true ,
    component: () => import('./views/visualizations/Bars.vue') ,
  },
  { 
    path: '/:lang/ci5-2.0/dataviz/plus/population_pyramid', 
    name: 'dataviz_population_pyramid_ci5plus',
    ci5plus: true ,
    component: () => import('./views/visualizations/PopulationPyramid.vue') ,
  },
  // -------------- DATAVIZ - Compare (CI5I_XII) ----------------
  { 
    path: '/:lang/ci5-2.0/dataviz/all/volumes', 
    name: 'dataviz_volumes',
    component: () => import('./views/visualizations/Volumes.vue') ,
  },
  { 
    path: '/:lang/ci5-2.0/dataviz/all/ranking', 
    name: 'dataviz_ranking',
    component: () => import('./views/visualizations/Ranking.vue') ,
  },
  { 
    path: '/:lang/ci5-2.0/dataviz/all/bar_compare', 
    name: 'dataviz_compare',
    component: () => import('./views/visualizations/BarCompare.vue') ,
  },
  { 
    path: '/:lang/ci5-2.0/dataviz/all/trends_volumes', 
    name: 'dataviz_trends_volumes',
    component: () => import('./views/visualizations/TrendsAccrossVolumes.vue') ,
  },
  //-------------------------------------------------------------------
  { 
    path: '/:lang/dataviz/volume', 
    name: 'dataviz_volume',
    component: () => import('./views/visualizations/Volume.vue') ,
  }
] ; 

const Router = new VueRouter({
  mode: 'history',
  linkExactActiveClass: 'is-active',
  base: process.env.BASE_URL ,
  beforeEnter: Trans.routeMiddleware,
  routes : routes_,
  scrollBehavior(to, from, savedPosition) {
    // `to` and `from` are both route objects
    // console.info("scrollBehavior",to,from,savedPosition)
    if ( to.hash ) {
      return { selector: to.hash }
    }
    else
      return { x: 0, y: 0 }
  }
})

Router.afterEach((to, from) => {
  let routing = to.path.split('/');
  
  let pathParams = to.path.replace(/\/+$/, '').split('/').filter(Boolean); // ['iacr','en','ci5-2.0','dataviz','01','bars']
  let datavizIndex = pathParams.indexOf('dataviz');
  Router.app.$store.commit('setVolume',pathParams[datavizIndex+1]) ; 

  // console.log("store volume in router",Router.app.$store.state.volume);

  delete routing[0] ; delete routing[1] ; 
  // console.info("Router.afterEach to",to);
  routing.filter((d)=>{ return true })
  if ( to.name != 'home')
  {
    // console.log("change router",to.name,
    setTimeout(() => {
      $('.header-menu-links .menu-item:first-child a').removeClass('router-link-active') ;
    }, 250 )   
  }
  document.querySelector('html').className = routing.join(' ').trim(); 
}); 

export default Router ; 